import { StaffCapability, StaffMember, StaffShift } from '@/api'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'

type StaffFormProps = {
  value: StaffMember
  onChange: (value: StaffMember) => void
  onSubmit: () => void
  onCancelEdit: () => void
  isEditing: boolean
  disabled?: boolean
}

const shiftOptions = [
  { label: '昼', value: StaffShift.DAY },
  { label: '夕', value: StaffShift.EVENING },
  { label: '夜', value: StaffShift.NIGHT },
  { label: 'オペレーター', value: StaffShift.OPERATOR },
]

const capabilityOptions = [
  { label: '◯', value: StaffCapability.ENABLED },
  { label: '△', value: StaffCapability.PARTIAL },
  { label: '✕', value: StaffCapability.DISABLED },
]

const StaffForm = ({ value, onChange, onSubmit, onCancelEdit, isEditing, disabled }: StaffFormProps) => {
  return (
    <Card title={isEditing ? 'スタッフ編集' : 'スタッフ追加'}>
      <div className="flex flex-column gap-3">
        <div className="flex flex-column gap-2">
          <label className="font-medium">名前</label>
          <InputText
            value={value.name}
            onChange={(e) => onChange({ ...value, name: e.target.value })}
            placeholder="例: 山田"
            disabled={disabled}
          />
        </div>

        <div className="flex flex-column gap-2">
          <label className="font-medium">勤務シフト</label>
          <Dropdown
            value={value.shift}
            options={shiftOptions}
            onChange={(e) => onChange({ ...value, shift: e.value as StaffShift })}
            optionLabel="label"
            optionValue="value"
            placeholder="シフトを選択"
            disabled={disabled}
          />
        </div>

        <div className="flex flex-column gap-2">
          <label className="font-medium">担当可能業務</label>
          <div className="grid">
            <div className="col-12 md:col-4 flex flex-column gap-2">
              <label className="text-sm">便蓋品</label>
              <Dropdown
                value={value.can_handle_lidded}
                options={capabilityOptions}
                onChange={(e) => onChange({ ...value, can_handle_lidded: e.value as StaffCapability })}
                optionLabel="label"
                optionValue="value"
                disabled={disabled}
              />
            </div>
            <div className="col-12 md:col-4 flex flex-column gap-2">
              <label className="text-sm">外観品</label>
              <Dropdown
                value={value.can_handle_appearance}
                options={capabilityOptions}
                onChange={(e) => onChange({ ...value, can_handle_appearance: e.value as StaffCapability })}
                optionLabel="label"
                optionValue="value"
                disabled={disabled}
              />
            </div>
            <div className="col-12 md:col-4 flex flex-column gap-2">
              <label className="text-sm">その他</label>
              <Dropdown
                value={value.can_handle_other}
                options={capabilityOptions}
                onChange={(e) => onChange({ ...value, can_handle_other: e.value as StaffCapability })}
                optionLabel="label"
                optionValue="value"
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        <div className="flex align-items-center gap-2">
          <Button
            label={isEditing ? '更新' : '追加'}
            icon={isEditing ? 'pi pi-check' : 'pi pi-plus'}
            onClick={onSubmit}
            disabled={disabled}
          />
          {isEditing && (
            <Button
              label="キャンセル"
              icon="pi pi-times"
              outlined
              onClick={onCancelEdit}
              disabled={disabled}
            />
          )}
        </div>
      </div>
    </Card>
  )
}

export default StaffForm
